import { useSelector } from 'react-redux';
import { getCurrentContractMessages } from '@app/reducers/current-contract';
import type { RootState } from '@app/reducers';

const emptyMessages = Object.freeze([]);

const useCurrentMessages = () => {
  const messages = useSelector<RootState, ReturnType<typeof getCurrentContractMessages>>(
    getCurrentContractMessages,
  );

  return messages || emptyMessages;
};

export default useCurrentMessages;
